goog.provide("shadow.js.shim.module$$zip_js$zip_js$lib$zip_no_worker");
goog.provide("module$shadow_js_shim_module$$zip_js$zip_js$lib$zip_no_worker");
shadow.js.shim.module$$zip_js$zip_js$lib$zip_no_worker = shadow.js.nativeProvides["@zip.js/zip.js/lib/zip-no-worker.js"] = shadow$bridge("@zip.js/zip.js/lib/zip-no-worker.js");
module$shadow_js_shim_module$$zip_js$zip_js$lib$zip_no_worker.default = shadow.js.shim.module$$zip_js$zip_js$lib$zip_no_worker;
